import { itemCode } from "@/features/modules/utility/modules/itemCode";
import { moveWarehouseLocation } from "@/features/modules/utility/modules/moveWarehouseLocation/";

export const featuresUtilityModules = [itemCode, moveWarehouseLocation];
